
































import {Component, Vue} from 'vue-property-decorator';
import Login from './views/Login.vue';
import user from '@/store/modules/user';
import version from '@/store/modules/version';
import alert from '@/store/modules/alert';
import IconSet from '@/components/IconSet.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import NewsModal from '@/components/NewsModal.vue';
import InfoModal from '@/components/InfoModal.vue';
import WelcomeModal from '@/components/WelcomeModal.vue';
import {User} from '@/store/models';
import Bowser from 'bowser';
import GlobalSpinner from '@/components/GlobalSpinner.vue';
import language from '@/store/modules/language';
import deck from '@/store/modules/deck';

@Component({
  components: {GlobalSpinner, IconSet, Login, ErrorModal, NewsModal, InfoModal, WelcomeModal},
})
export default class App extends Vue {
  initiated: boolean = false;
  fullscreen: boolean = false;

  pageStyle: string = '';

  async onFullscreenChange() {
    this.fullscreen = !this.fullscreen;
    let route = this.$router.currentRoute.name;
    if (!route) {
      route = '';
    }
    if (!this.fullscreen && route.startsWith('presentation')) {
      if (route === 'presentation-deck') {
        const docId = await deck.save();
        if (docId !== deck.DocumentId) {
          await user.getUser('Uppdaterar presentation');
        }
      }
      this.$router.back();
    }
  }

  beforeUpdate() {
    const route = this.$router.currentRoute.name;
    if (!route) {
      return;
    }
    if (!route.startsWith('presentation') && Vue.prototype.$l !== 'sv') {
      Vue.prototype.$l = 'sv';
    }
  }

  addErrorHandlers() {
    window.onerror = (message, source, lineno, colno, error) => {
      const errorData = {
        message,
        source,
        lineNumber: lineno,
        columnNumber: colno,
        stack: error ? error.stack : '',
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
        url: window.location.href,
      };

      fetch('/api/log-error', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(errorData),
      }).catch((err) => {
        // Fallback logging if the error logging itself fails
        console.error('Failed to send error to backend:', err);
      });

      // Also catch unhandled promise rejections
      window.addEventListener('unhandledrejection', (event) => {
        const promiseErrorData = {
          message: event.reason ? event.reason.message : '' || 'Unhandled Promise Rejection',
          stack: event.reason ? event.reason.stack : '',
          timestamp: new Date().toISOString(),
          url: window.location.href,
          type: 'unhandledrejection',
        };

        fetch('/api/log-error', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(promiseErrorData),
        }).catch(console.error);
      });

      // Return true to prevent the default browser error handling
      return true;
    };

    // Also catch console.error calls
    const originalConsoleError = console.error;
    console.error = (...args) => {
      const errorData = {
        message: args.map((arg) => String(arg)).join(' '),
        timestamp: new Date().toISOString(),
        url: window.location.href,
        type: 'console.error',
      };

      fetch('/api/log-error', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(errorData),
      }).catch((err) => {
        originalConsoleError('Failed to send console.error to backend:', err);
      });

      // Call the original console.error
      originalConsoleError.apply(console, args);
    };
  }

  async mounted() {
    if (!this.supportedBrowser) {
      return;
    }

    this.addErrorHandlers();

    if (window.location.pathname.indexOf('/print/') !== -1) {
      this.pageStyle = `
        <style type="text/css" media="print">
            @page {
                size: 1280px 720px;
                margin: 0
            }
            html {
                background: white;
            }
            .sheet {
                background: white;
                box-shadow: none;
                margin: 0 auto;
            }
        </style>`;
      this.initiated = true;
      return;
    }

    if (window.location.pathname.indexOf('/pdf/') !== -1) {
      this.pageStyle = `
        <style type="text/css" media="">
            @page {
                size: 209mm 297mm;
                margin: 0;
            }
            html {
                background: white;
                font-size: 14px;
            }
            .sheet {
                background: white;
                box-shadow: none;
                margin: 0 auto;
            }
        </style>`;
      this.initiated = true;
      return;
    }

    if (window.location.pathname.indexOf('/webreport/') !== -1) {
      this.initiated = true;
      return;
    }

    document.addEventListener('fullscreenchange', this.onFullscreenChange);
    document.addEventListener('mozfullscreenchange', this.onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
    document.addEventListener('msfullscreenchange', this.onFullscreenChange);

    if (window.location.pathname.indexOf('/shared/') !== -1) {
      this.initiated = true;
      return;
    }

    if (user.user === null && !user.loggingIn) {
      await user.getUser('Hämtar bolagsdata');
      this.initiated = true;
    }
    await version.getVersion();
    if (process.env.NODE_ENV !== 'development') {
      window.setInterval(async () => {
        await version.getVersion();
        await user.checkUser();
      }, 5 * 1000);
    }
  }

  closeError() {
    alert.setError(null);
  }

  closeNews() {
    alert.setNews(null);
  }

  get lang() {
    return language.language;
  }

  get isPdf() {
    return window.location.pathname.indexOf('/pdf/') !== -1;
  }

  get isWebreport() {
    return window.location.pathname.indexOf('/webreport/') !== -1;
  }

  get supportedBrowser() {
    return !Bowser.msie;
  }

  get pendingFetch() {
    return user.fetchingData;
  }

  get user(): User | null {
    return user.user;
  }

  get error(): any {
    return alert.error;
  }

  get news(): any {
    return alert.news;
  }
}
